export { default as NSkeleton, skeletonProps } from './src/Skeleton';
